var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('ContratoTomador',{attrs:{"contratoId":_vm.contratoId}})],1),_c('b-col',{attrs:{"md":"9"}},[_c('ContratoDetalhes',{attrs:{"contratoId":_vm.contratoId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }